export class HfoCalculationService {
    ;
    static CalculateShipdetailsHfo(config1) {
        
        let Mainengine = config1;
        Mainengine.forEach((element) => {
            let MCR_KW = parseFloat(element.MCR_KW);
            element.MCR_HP = (MCR_KW * 1.34102).toFixed(2);
        })
        return Mainengine

    }
    static CalculateShipdetailsHfoAuxililaryengine(config) {
        ////
        let Auxiliaryengine = config;
        Auxiliaryengine.forEach((element) => {
            let MCR_KW = parseFloat(element.MCR_KW);
            element.MCR_HP = (MCR_KW * 1.34102).toFixed(2);
        })
        return Auxiliaryengine
    }
    static CalculateHfo(config1, config2, config3, config4, config5) {
        ;
        let mainengine = config1;
        let total = null;
        let me_fo_cons = null;
        let AE_Fo_consumption = null;
        let mainenginetotal = 0;
        let axililaryenginetotal = 0;
        let co2 = null;
        mainengine.forEach((ele, index) => {
            let start = parseFloat(ele.start);
            let end = parseFloat(ele.end);
            total = (end - start) * 60;
            ele.total = total;
            let mc_ctr_start = parseFloat(ele.mc_ctr_start);
            let mc_ctr_end = parseFloat(ele.mc_ctr_end);
            me_fo_cons = (mc_ctr_end - mc_ctr_start);
            ele.me_fo_cons = me_fo_cons.toFixed(2);

            let meload = 0;
            let me_load = parseFloat(ele.me_load);
            if (ele.me_load_unit == true) {
                meload = (me_load / 1.341);
            } else {
                meload = (me_load);
            }

            let SDmainengine = config4;
            let ME_MCR = 0;
            let ME = 0;

            ME_MCR = (meload / SDmainengine[index]["MCR_KW"]);
            ele.me_load_mcr = ME_MCR.toFixed(2);

            ME = (ME_MCR * SDmainengine[index]["Exh_Flow_100"]);
            ele.main_engine = ME.toFixed(2);;

            mainenginetotal = mainenginetotal + ME;

            co2 = parseFloat(ele.co2);

        });

        let axililaryengine = config2;
        axililaryengine.forEach((ele, index) => {
            let AE_FO_CTR_Start = parseFloat(ele.AE_FO_CTR_Start);
            let AE_FO_CTR_End = parseFloat(ele.AE_FO_CTR_End);
            AE_Fo_consumption = (AE_FO_CTR_End - AE_FO_CTR_Start);
            ele.AE_Fo_consumption = AE_Fo_consumption.toFixed(2);

            let Aeload = 0;
            let AE_Load1 = parseFloat(ele.AE_Load1);
            if (ele.AE_Load1_unit == true) {
                Aeload = (AE_Load1 / 1.341)
            } else {
                Aeload = (AE_Load1)
            }

            let SDauxililaryengine = config5;
            let AE_MCR = 0;
            let AE = 0;
            AE_MCR = Aeload / SDauxililaryengine[index]["MCR_KW"];
            ele.AE_Load_mcr = AE_MCR.toFixed(2);

            AE = (ele.AE_Load_mcr * SDauxililaryengine[index]["Exh_Flow_100"]);
            ele.Axililary_engine = AE.toFixed(2);;

            axililaryenginetotal = axililaryenginetotal + AE;

        });
        let totalgasflow = (mainenginetotal + axililaryenginetotal).toFixed(2);
        let intermediate_co2_kg_h = (co2 * totalgasflow).toFixed(2);
        let intermediate_co2_kg_m = (intermediate_co2_kg_h / 60).toFixed(2);

        let Co2_kg_Total_duration = ((intermediate_co2_kg_h / 60) * total).toFixed(2);
        let Co2_kg_Tonnes_duration = (Co2_kg_Total_duration / 1000).toFixed(2);
        let co2_kg_total = (config3.MEPC * (me_fo_cons + AE_Fo_consumption)).toFixed(2);

        let t_co2_fuel = (Co2_kg_Tonnes_duration / (me_fo_cons + AE_Fo_consumption)).toFixed(2);
        return {
            mainengine,
            axililaryengine,
            totalgasflow,
            intermediate_co2_kg_h,
            intermediate_co2_kg_m,
            t_co2_fuel,
            Co2_kg_Total_duration,
            Co2_kg_Tonnes_duration,
            co2_kg_total
        }

    }




}